module.exports = __webpack_public_path__ + "static/media/bgLogin.913a1048.png";